import { Spinner } from 'cpool-components/state/Spinner';
import { SpinnerSize } from 'cpool-components/state/Spinner/types';
import { useTranslation } from 'react-i18next';
import { LuFileText, LuTrash2 } from 'react-icons/lu';

import { formatFileSize } from './formatFileHint';

type Props = {
    name: string;
    size: number;
    onRemove: () => void;
    removing?: boolean;
};

export const UploadedFileRow: React.FC<Props> = ({ name, onRemove, removing, size }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-2 rounded-md border border-grey-outline-light px-3 py-2 text-sm text-midnight">
            <LuFileText size={16} className="shrink-0 text-midnight-placeholder" />
            <span className="truncate">{name}</span>
            <span className="ml-auto whitespace-nowrap text-xs text-midnight-placeholder">{formatFileSize(size)}</span>
            <button
                type="button"
                aria-label={t('FILE_UPLOAD.REMOVE_DOCUMENT')}
                className="shrink-0 text-midnight disabled:cursor-not-allowed disabled:opacity-50"
                disabled={removing}
                onClick={onRemove}
            >
                {removing ? <Spinner size={SpinnerSize.SMALL} /> : <LuTrash2 size={16} />}
            </button>
        </div>
    );
};
